import { useState, useEffect } from 'react';

const API_URL = 'https://app.thundermaxhome.com/api.php';

export function useQueue(user) {
  const [jobs, setJobs] = useState([]);

  // ดึงข้อมูลคิวงาน
  const fetchJobs = async () => {
    try {
      const res = await fetch(`${API_URL}?action=get_jobs`);
      const data = await res.json();
      if (data.success) {
        setJobs(data.data);
      }
    } catch (error) {
      console.error("Fetch jobs error:", error);
    }
  };

  useEffect(() => {
    fetchJobs();
    // แอบดึงข้อมูลใหม่ทุกๆ 1 นาทีเบาๆ
    const interval = setInterval(fetchJobs, 60000);
    return () => clearInterval(interval);
  }, []);

  // เพิ่มงานใหม่
  const addNewJob = async (jobData) => {
    const res = await fetch(`${API_URL}?action=add_job`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jobData)
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.message || 'บันทึกข้อมูลไม่สำเร็จ เซิร์ฟเวอร์ปฏิเสธ');
    
    fetchJobs(); // โหลดคิวงานใหม่ทันที
    return data;
  };

  // อัปเดตสถานะงาน / รายงานหน้างาน / อัปโหลดรูป
  const updateJobData = async (jobId, updateData) => {
    const res = await fetch(`${API_URL}?action=update_job`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: jobId, ...updateData })
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.message || 'อัปเดตข้อมูลไม่สำเร็จ');
    
    fetchJobs(); // โหลดคิวงานใหม่ทันที
    return data;
  };

  return { jobs, addNewJob, updateJobData, refreshJobs: fetchJobs };
}